import { useResetRecoilState } from 'recoil';

import {
  reasonForLateReasonIsOtherState,
  reasonForLateResponseDetailState,
  reasonForLateResponseIdState,
  responseDetailState,
  responseFilesState,
  responseSupportingFilesState,
  responseTypeIdIsConsultedInErrorState,
  responseTypeIdState,
} from 'store';

/**
 * The `useResetResponseFormState` function is a custom hook in TypeScript that handles the logic for
 * resetting the response form states.
 */
export const useResetResponseFormState = (): { resetForm: () => void } => {
  const resetResponseTypeIdIsConsultedInError = useResetRecoilState(
    responseTypeIdIsConsultedInErrorState
  );
  const resetResponseTypeId = useResetRecoilState(responseTypeIdState);
  const resetResponseDetail = useResetRecoilState(responseDetailState);
  const resetReasonForLateReasonIsOther = useResetRecoilState(reasonForLateReasonIsOtherState);
  const resetReasonForLateResponseId = useResetRecoilState(reasonForLateResponseIdState);
  const resetReasonForLateResponseDetail = useResetRecoilState(
    reasonForLateResponseDetailState
  );
  const resetResponseFiles = useResetRecoilState(responseFilesState);
  const resetSupportingFiles = useResetRecoilState(responseSupportingFilesState);

  const resetForm = () => {
    resetResponseTypeIdIsConsultedInError();
    resetResponseTypeId();
    resetResponseDetail();
    resetReasonForLateReasonIsOther();
    resetReasonForLateResponseId();
    resetReasonForLateResponseDetail();
    resetResponseFiles();
    resetSupportingFiles();
  };

  return {
    resetForm,
  };
};
